module.exports = __webpack_public_path__ + "assets/futurafuturisc-webfont.a1267c191a35049cab8c4fed36b2ddc33638c4d467ccc897b168e11112059531.woff";